import type { AdminRowActionItem } from "./admin-action-types";

export const ADMIN_ACTION_COLUMN_WIDTH_COMPACT = 140;
export const ADMIN_ACTION_COLUMN_WIDTH_DEFAULT = 180;
export const ADMIN_ACTION_COLUMN_WIDTH_PER_ACTION = 40;
export const ADMIN_ACTION_COLUMN_WIDTH_PADDING = 20;

export function countVisibleAdminRowActions(actions: AdminRowActionItem[]) {
  return actions.filter(
    (action) =>
      !action.hidden && (!action.disabled || action.loading || action.onClick || action.confirm),
  ).length;
}

export function resolveAdminActionColumnWidth(actionCount: number) {
  const normalizedCount = Math.max(1, Math.floor(Number.isFinite(actionCount) ? actionCount : 0));
  return Math.max(
    ADMIN_ACTION_COLUMN_WIDTH_COMPACT,
    normalizedCount * ADMIN_ACTION_COLUMN_WIDTH_PER_ACTION + ADMIN_ACTION_COLUMN_WIDTH_PADDING,
  );
}
